export enum EIFormTabs {
    main = 'main',
    changes = 'changes',
}

export enum EIFormTabTitles {
    main = 'Основная информация',
    changes = 'Журнал изменений'
}
